import type { Merge } from '@festina-life/core'
import {
  type FormikContextType,
  // oxlint-disable-next-line no-restricted-imports
  useFormikContext as useOriginalFormikContext,
} from 'formik'
import type { SchemaFieldDescription } from 'yup'

export type FormikStatusType = {
  hasFormValidated: boolean
  yupFields: Record<string, SchemaFieldDescription> | undefined
  shouldFieldsBeDisabled: boolean
  shouldShowChangesInForm: boolean
}

type FormikContext<T> = Merge<
  FormikContextType<T>,
  {
    status: FormikStatusType
    setStatus: (status: FormikStatusType) => void
  }
>

/**
 * Custom implementation of useFormikContext to ensure that status is typed
 */
export const useFormikContext = <T>() => {
  const formikContext = useOriginalFormikContext<T>()

  return formikContext as FormikContext<T>
}
